import React from 'react';
import { ENCOUNTER_COLORS, otherWorldInfo } from '../data/otherWorlds';

/** SVG works both inside the map scene and inline in the inspector. */
export function OtherWorldColors({ name, labels = false }: { name: string; labels?: boolean }) {
  const info = otherWorldInfo(name);
  if (!info) return null;
  const circles = <svg className="other-world-colors" width={info.colors.length * 24} height={24}
    viewBox={`0 0 ${info.colors.length * 24} 24`} role="img" aria-label={`Encounter colors: ${info.colors.join(', ')}`}>
    <title>{`Encounter colors: ${info.colors.join(', ')}`}</title>
    {info.colors.map((color, index) => <circle key={color} data-encounter-color={color}
      cx={12 + index * 24} cy={12} r={9} fill={ENCOUNTER_COLORS[color].fill} stroke="#142025" strokeWidth={3} />)}
  </svg>;
  return labels ? <div className="digital-location-world-colors">{circles}<span>{info.colors.join(', ')}</span></div> : circles;
}
